import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import { sendOTP } from "../../actions/loginActions";
import { renderAsHTML } from "../../utils/html";
import messages from "../messagesDescription";

const SwitchTwoFAMode = ({ twoFaModes, setOTPExpired, intl }) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const dispatch = useDispatch();
  const otp = useSelector(state => state.login.otp);

  useEffect(() => {
    if (otp && otp.expireInSeconds + otp.blockResendInSeconds > 5 * 60) {
      setIsDisabled(true);
      setTimeout(() => {
        setIsDisabled(false);
      }, (otp.blockResendInSeconds + otp.expireInSeconds - 5 * 60) * 1000);
    }
  }, [otp]);

  const switchOTP = twoFaMode => {
    dispatch(sendOTP(twoFaMode, true, intl));
    setOTPExpired(false);
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, otp.blockResendInSeconds * 1000);
  };
  return (
    <section style={{ marginTop: "30px" }}>
      {renderAsHTML("p", intl.formatMessage(messages.login.tryOtherTwoFaMode))}
      <div>
        <strong>{intl.formatMessage(messages.loginSendAgainVia)}</strong>
        {"  "}
        {twoFaModes.map((mode, index) => {
          return (
            <Fragment key={mode.twoFaMode}>
              <button
                style={{ margin: "0 8px" }}
                type="button"
                disabled={isDisabled}
                onClick={() => switchOTP(mode.twoFaMode)}
                className="link"
              >
                <span
                  style={
                    isDisabled ? { fontSize: "1.125rem", color: "grey" } : { fontSize: "1.125rem" }
                  }
                >
                  <u>{mode.twoFaMode}</u>
                </span>
              </button>
              {index < twoFaModes.length - 1 && <strong> {intl.formatMessage(messages.loginOr)} </strong>}
            </Fragment>
          );
        })}
      </div>
      <p style={{ fontSize: "0.75rem", marginLeft: "0.5rem" }}>
        {intl.formatMessage(messages.twoFAResendCooldown, {
          value: otp.blockResendInSeconds
        })}
      </p>
    </section>
  );
};

SwitchTwoFAMode.propTypes = {
  twoFaModes: PropTypes.array,
  setOTPExpired: PropTypes.func,
  intl: intlShape.isRequired,
};

export default injectIntl(SwitchTwoFAMode);



// WEBPACK FOOTER //
// ./components/twoFA/SwitchTwoFAMode.js